<template>
  <v-container>
    <v-form @submit.prevent="performAction()">
      <v-text-field label="E-Mail-Adresse" type="email" v-model="username" />
      <v-text-field v-if="mode === 'login'" label="Passwort" v-model="password"
                    :type="showPassword ? 'text' : 'password'" :append-inner-icon="!showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append-inner="showPassword = !showPassword"/>
      <v-btn
        block
        color="primary"
        :loading="loading"
        :disabled="loading"
        type="submit"
      >{{ mode === 'login' ? 'Anmelden' : 'Passwort zurücksetzen' }}</v-btn>
      <v-btn v-if="mode !== 'reset'" class="mt-2" block @click="mode = 'reset'" elevation="0">Passwort zurücksetzen</v-btn>
      <v-btn v-if="mode !== 'login'" class="mt-2" block @click="mode = 'login'" elevation="0">Abbrechen</v-btn>
    </v-form>
  </v-container>
</template>

<script lang="ts" setup>
import {doAlert} from '@/util';
import {ref} from 'vue';
import {resetPassword} from '@/api/module/misc';
import {useSettings} from '@/store/settings';

const mode = ref('login' as 'login' | 'reset');
const showPassword = ref(false);

const loading = ref(false);
const username = ref(process.env.NODE_ENV == 'development' ? 'demo@ncn.de' : '');
const password = ref(process.env.NODE_ENV == 'development' ? 'Abcd1234!' : '');
const settingsStore = useSettings();

async function doLogin() {
  console.log('login');
  await settingsStore.login(username.value, password.value);
}

async function doResetPassword() {
  await resetPassword(username.value);
  await doAlert('Passwort erfolgreich zurückgesetzt');
  mode.value = 'login';
}

async function performAction() {
  console.log('action');
  try {
    loading.value = true;
    mode.value === 'login' ? await doLogin() : await doResetPassword();
  } catch (err: any) {
    await doAlert(err.message, 'Fehler');
  } finally {
    loading.value = false;
  }
}

defineExpose({
  username,
  password,
  loading,
  performAction,
  mode,
  showPassword,
});
</script>
